<template>
  <vue-final-modal v-model="appealModalVisible" name="realtime-transfer-appeal-dialog"
    :classes="['realtime-transfer-appeal-dialog__container']"
    :styles="{ display: 'flex', alignItems: 'center', justifyContent: 'center' }"
    :content-class="['realtime-transfer-appeal-dialog__content', 'v--modal-box', 'v--modal']"
    :click-to-close="true" :lock-scroll="true"
    @opened="onAppealModalOpened" @closed="onAppealModalClosed"
    @before-close="handleBeforeClose">
    <div style="text-align: left;">
      <p style="color: gray; border: 1px solid; display: inline;">PR</p>
    </div>
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeAppealDialog" icon="el-icon-circle-close" style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div class="setting">
      <div style="text-align: center;">
        <div v-if="dialogInfo.logoImage" style="display: inline-block; min-width: 100%; text-align: center; padding: 10px;">
          <img :src="dialogInfo.logoImage" style="max-width: 100%;" @load="onLogoImageLoad">
        </div>
        <p v-if="formattedText1" style="font-size: 16px; font-weight: bold; text-align: center; margin-bottom: 10px;"
          v-html="formattedText1"></p>
        <div v-if="formattedText2" class="rt-appeal-footer-text">
          <rt-common-footer-text :fallback="formattedText2" />
        </div>
        <div v-if="appealPoints.length > 0" style="display: inline-block; min-width: 100%; text-align: center; margin-bottom: 20px;">
          <div
            style="text-align: left; margin-left: 0.5rem; font-size: 120%; font-weight: bold; line-height: 1.3; margin-bottom: 20px;">
            <div v-for="(point, idx) in appealPoints" :key="idx"
              :style="{ display: 'flex', alignItems: 'center', paddingBottom: idx === appealPoints.length - 1 ? '0' : '10px' }">
              <p
                style="display: block; background:#0F9934; width: 20px; height: 20px; border-radius: 50%; margin-right: 10px;">
              </p>
              <p style="font-size: 120%; font-weight: bold;">
                <span v-if="point.sub" style="font-size: 80%;">{{ point.sub }}</span>
                <br v-if="point.sub">
                {{ point.main }}
              </p>
            </div>
          </div>
        </div>
        <p v-if="dialogInfo.termurl" style="font-size: 80%; margin-bottom: 10px;">
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          {{ dialogInfo.clientName }}の<a :href="dialogInfo.termurl" target="_blank">利用規約</a>、<a
            :href="dialogInfo.privacyurl" target="_blank">個人情報保護方針</a>を
          <br>確認して{{ dialogInfo.clientServiceName }}に登録することになります。
        </p>
        <div>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
            v-if="!isAppealSended"
            style="background-color: #E3165C; border-color: #E3165C; font-size: 120%; width: 100%;"
            @click="sendRealtimeTransferAppealConsult()">{{ btnText }}</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-else
            style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeAppealDialog()">送信しました</el-button>
          <rt-common-other-job-button
            class="rt-appeal-other-job"
            :visible="showOtherJobButton"
            :label="rtOtherJobButtonLabel"
            @click="onRtAppealOtherJobBtnClick"
          />
        </div>
      </div>
    </div>
  </vue-final-modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script setup lang="ts">
import { computed, ref } from 'vue'
import { useRtDialogBase, registerAllRtConsultEmitters } from '@/composables/useRtDialogBase'
import { useRtTextFormat } from '@/composables/useRtTextFormat'
import RtCommonFooterText from '@/components/realtimeTransfer/RtCommonFooterText.vue'
import RtCommonOtherJobButton from '@/components/realtimeTransfer/RtCommonOtherJobButton.vue'

const text1 = ref('ダウンロードが完了しました！')
const text2 = ref('')

const base = useRtDialogBase({
  openDialogEventName: 'open-realtimetransferappeal-dialog',
  primaryConsultEventName: 'send-realtimetransferappeal-consult',
  primaryConsultHandlerKey: 'sendRealtimeTransferAppealConsult',
  defaultPermissionType: 4,
  defaultClientId: 'medley_link',
  defaultDialogName: 'medley_link-dialog',
  afterApplyInfo: ({ info }) => {
    text1.value = info.text_1 ?? 'ダウンロードが完了しました！'
    text2.value = info.text_2 ?? ''
  }
})

// RealtimeTransferCommon と同じく、各クライアントの送客 hub イベント群を一括追加 listen。
// → AppealDialog は「Medley 互換 (sendRealtimeTransferAppealConsult) + 全 RT 共通 send-*」の上位互換ハブとなる。
registerAllRtConsultEmitters(base)

const dialogInfo = base.dialogInfo

const { formattedText: formattedText1 } = useRtTextFormat({
  text: text1,
  dialogInfo,
  spMaxCharsKey: 'text_1_sp_max_chars',
  pcMaxCharsKey: 'text_1_pc_max_chars'
})
const { formattedText: formattedText2 } = useRtTextFormat({
  text: text2,
  dialogInfo,
  spMaxCharsKey: 'text_2_sp_max_chars',
  pcMaxCharsKey: 'text_2_pc_max_chars',
  spOnly: true
})
/** アピールポイント配列（[{ main, sub? }]） */
const appealPoints = computed<Array<{ main: string; sub?: string }>>(() => {
  const raw = dialogInfo.value.appealPoints
  return Array.isArray(raw) ? raw : []
})
/** 送信ボタン文言（既定: 「同意する」） */
const btnText = computed<string>(() => dialogInfo.value.btn_text ?? '同意する')
const showOtherJobButton = base.showOtherJobButton
const rtOtherJobButtonLabel = base.rtOtherJobButtonLabel

function onRtAppealOtherJobBtnClick () {
  base.onRtOtherJobBtnClick()
}

// テンプレート互換のための別名
const appealModalVisible = base.modalVisible
const isAppealSended = base.isSended
const closeAppealDialog = base.closeDialog
const onAppealModalOpened = base.onModalOpened
const onAppealModalClosed = base.onModalClosed
const handleBeforeClose = base.handleBeforeClose
const fullscreenLoading = base.fullscreenLoading
const onLogoImageLoad = base.onLogoImageLoad
const sendRealtimeTransferAppealConsult = base.sendRealtimeTransferAppealConsult
</script>

<style scoped lang="scss">
/* content-class は VueFinalModal 内部のノードのため scoped だけだと [data-v-*] が付かない → :deep() で子まで適用 */
:deep(.realtime-transfer-appeal-dialog__container) {
  box-sizing: border-box;
  align-items: flex-start !important;
  overflow-y: auto;
  padding: 40px 0;
  -webkit-overflow-scrolling: touch;
}

:deep(.realtime-transfer-appeal-dialog__content) {
  background: #fff;
  box-sizing: border-box;
  flex: 0 1 auto;
  align-self: center;
  width: 600px;
  max-width: 100%;
  height: auto;
  margin-top: auto;
  margin-bottom: auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: visible;
}

.rt-appeal-footer-text {
  margin-bottom: 10px;
}

:deep(.rt-appeal-other-job .rt-common-other-job__btn) {
  background: none;
  border: none;
  padding: 0;
  width: 100%;
}

:deep(.rt-appeal-other-job .rt-common-other-job__btn > span) {
  margin-top: 0;
  display: block;
  width: 100%;
}

:deep(.rt-appeal-other-job .rt-common-other-job__btn > span > span) {
  font-weight: bold;
  display: block;
  background: rgb(227, 22, 92);
  border-color: rgb(227, 22, 92);
  border-style: solid;
  border-width: 1px;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 18px;
  padding: 18px 20px;
}
</style>
